import { Flex, Text } from "@aws-amplify/ui-react";
import React from "react";
import { Promotion } from "../types";

type Props = {
  promotion: Promotion;
};

export default function SaleBanner({ promotion }: Props) {
  const { startText, code, endText, primaryColor, fontColor } = promotion;
  return (
    <Flex
      gap={"large"}
      fontFamily={"Poppins"}
      padding={{ base: "small", medium: "small xl" }}
      className="shiny-box"
      backgroundColor={primaryColor}
      justifyContent={"center"}
      position={"relative"}
    >
      <Text
        color={fontColor}
        fontSize={{ base: "medium", medium: "large" }}
        textAlign={"center"}
      >
        {startText} <b>{code}</b> {endText}
      </Text>
      {/* <Text
        color={"white"}
        fontSize={{ base: "medium", medium: "large" }}
        textAlign={"center"}
      >
        🎊 Up to <b>50% OFF</b> for Back To School until September 30! 🎊
      </Text> */}
    </Flex>
  );
}
